export default {
    answered: 'Répondu',
    attempted: 'Tentative',
    calling: 'En cours',
    delivered: 'Livré',
    delivery_failed: 'Échec',
    error: 'Erreur',
    failed: 'Échec',
    interrupted: 'Interrompu',
    invalid: 'Invalide',
    pending: 'En attente',
    read: 'Lu',
    sent: 'Envoyé',
    unanswered: 'Non-répondu',
    unread: 'Non lu',
};
